/** Matches the API, which rejects shorter HubSpot searches with a 400. */
export const HUBSPOT_MIN_SEARCH_LENGTH = 3;

export const HUBSPOT_SEARCH_DEBOUNCE_MS = 300;

/** `Company.name` is `max_length=50` in the API. */
const COMPANY_NAME_MAX_LENGTH = 50;

/**
 * Name `maxLength` rule shared by the company and demo dialogs. HubSpot names
 * run longer than the API allows, so an auto-filled name can need trimming.
 */
export const COMPANY_NAME_MAX_LENGTH_RULE = {
  value: COMPANY_NAME_MAX_LENGTH,
  message: `Company names can be at most ${COMPANY_NAME_MAX_LENGTH} characters`,
};
